import {GlobalWrapper, SectionWrapper} from "shared/Styles/Wrappers";
import styled                          from "styled-components";

export const Container = styled(GlobalWrapper)`
    padding: 64px 0;
    background-color: ${({color}) => (color ? color : "#fff")};
    margin-top: -1px;
    margin-bottom: -1px;
`;

export const Wrapper = styled(SectionWrapper)`
    display: flex;
    justify-content: center;

    .gatsby-image-wrapper {
        width: 200px;
        height: auto;
    }
`;
